import { filter } from 'lodash'
import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import {
  API_LISTAR_TIPO_AGUA,
  API_CRIAR_TIPO_AGUA,
  API_EXCLUIR_TIPO_AGUA,
  API_ATUALIZAR_TIPO_AGUA,
} from 'store/modules/api/tipoAgua.actions'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_TIPO_AGUA.success:
      return payload.sort((a, b) => a.tipo.localeCompare(b.tipo))
    case API_CRIAR_TIPO_AGUA.success:
      return [...state, payload].sort((a, b) => a.tipo.localeCompare(b.tipo))
    case API_ATUALIZAR_TIPO_AGUA.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    case API_EXCLUIR_TIPO_AGUA.success:
      return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_TIPO_AGUA)

const isSaving = loadingReducer(false, API_CRIAR_TIPO_AGUA)
const isUpdate = loadingReducer(false, API_ATUALIZAR_TIPO_AGUA)

export default combineReducers({
  lista,
  isCarregandoLista,
  isSaving,
  isUpdate,
})
